
        import 'Button.ba362a3.css-module'
        export default {"button":"button_Button_ba362a3","solid":"solid_Button_ba362a3","link":"link_Button_ba362a3","primary":"primary_Button_ba362a3","secondary":"secondary_Button_ba362a3","light":"light_Button_ba362a3","dark":"dark_Button_ba362a3","darkSecondary":"darkSecondary_Button_ba362a3"}
    